import { cn } from "~/lib/utils";

/**
 * Renders translation content that may be plain text or HTML (e.g. from TYPO3 RTE).
 * Uses dangerouslySetInnerHTML only when the content contains HTML tags.
 */
export function TranslationContent({
  content,
  as: Component = "span",
  className,
}: {
  content: string | null | undefined;
  as?: "span" | "p" | "div";
  className?: string;
}) {
  if (content == null || content === "") return null;

  const hasHtml = /<[a-z][\s\S]*>/i.test(content);

  if (hasHtml) {
    return (
      <Component
        className={cn("[&_a]:underline list-styling", className)}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return <Component className={cn(className)}>{content}</Component>;
}
